export default __webpack_public_path__ + "static/media/cards2.cd4f4aac.png";